import { render, staticRenderFns } from "./taskflow.vue?vue&type=template&id=12eb4946&scoped=true"
import script from "./taskflow.vue?vue&type=script&lang=js"
export * from "./taskflow.vue?vue&type=script&lang=js"
import style0 from "./taskflow.vue?vue&type=style&index=0&id=12eb4946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb4946",
  null
  
)

export default component.exports